module.exports = __webpack_public_path__ + "img/bug.33bb0fd4.svg";